var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBalancingIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 428 499.9",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "current"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M166.7,100.9v43.4c0,17.3,18.7,28.1,33.6,19.4l105.6-61c14.9-8.6,14.9-30.2,0-38.8L200.3,3c-14.9-8.6-33.6,2.2-33.6,19.4 v18.6C71.7,59.9,0,143.6,0,244.2c0,26.5,5,51.8,14,75c0,0,11.1,25,36.1,17S67.8,297,67.8,297c-6.2-16.4-9.6-34.2-9.6-52.8 C58.2,176,104.1,118.5,166.7,100.9z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M428,245.7c0-26.5-5-51.8-14-75c0,0-11.1-25-36.1-17c-25,8-17.7,39.2-17.7,39.2c6.2,16.4,9.6,34.2,9.6,52.8             c0,68.9-46.8,126.8-110.3,143.8v-33.9c0-17.2-18.7-28-33.6-19.4l-105.6,60.9c-14.9,8.6-14.9,30.2,0,38.8l105.6,60.9             c14.9,8.7,33.6-2.1,33.6-19.3v-28.3C355.4,431.1,428,346.9,428,245.7z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBalancingIcon);
export default __webpack_public_path__ + "static/media/balancing-icon.2fa10fcefaaab4b84a097d3ea2037028.svg";
export { ForwardRef as ReactComponent };